export const ADMIN = '/'
export const SIGN_IN = '/signin'